import React from "react";
import { useParams } from "react-router-dom";
import Data from '../data/home';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Search() {
  const { query } = useParams();
  const safeQuery = query.replace(/[^a-zA-Z0-9 ]/g, '');
  const [value, setValue] = useState(query.replace(/[^a-zA-Z0-9 ]/g, ''));
  const [heroData, setHeroData] = useState(Data);
  const [results, setResults] = useState([]);
  if ({query} === null) {
    setValue({});
  }
  const navigate = useNavigate();

  useEffect(() => {
    
    const fetchData = () => {
      try {
        setValue(safeQuery);
        
        setResults(heroData.marketing.filter((result) => {
            return (
                result.title.toLowerCase().includes(safeQuery.toLowerCase()) ||
                result.body.toLowerCase().includes(safeQuery.toLowerCase()) ||
                result.tags.includes(safeQuery.toLowerCase()) || 
                result.title.toLowerCase().includes(safeQuery.toLowerCase() + 's') ||
                result.body.toLowerCase().includes(safeQuery.toLowerCase() + 's') ||
                result.tags.includes(safeQuery.toLowerCase() + 's')
                )
            })
        );
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    console.log(query);
  }, [safeQuery]);

  if (results.length > 0 ) {
    return (
        <div className="container" style={{ padding: "30px 10px"}}>
            <h1>Showing {results.length == 1 ? results.length + " Result" : results.length + " Results"} for : "{value}"</h1>
            <div style={{padding: '20px 0'}}>
          { 
            results.map(result => (
                <li key={"result" + result.id} style={{listStyle: 'none', display: 'block'}}>
                    <Link to={result.url} style={{ textDecoration: 'none'}}><img src={"/images/" + result.image} style={{maxWidth: '200px', height: 'auto', border: '0', float: 'left', margin: '0 20px 20px 0'}}></img><h3 style={{ color: '#710800' }}>{result.title}</h3></Link>
                    <div>{result.body}</div>
                    <div><span style={{ fontWeight: '600'}}>tags: </span> 
                        {result.tags.map((tag, index) => (
                            results.length - 1 == index ?
                                <><Link to={"/Search/" + tag}>{tag} </Link></>:
                                <><Link to={"/Search/" + tag}>{tag} </Link> | </>
                        )
                    )}
                    </div>
                    <div style={{clear:'both'}}></div>
                    </li> 
                )
            )
          }
          </div>
        </div>
      );
  }
  return (
    <div className="container" style={{ padding: "30px 10px"}}>
        <h1>Showing {results.length} Results for : "{value}"</h1>
        <div style={{padding: '20px 0'}}>No Results Found.</div>
    </div>
  );

}